import React from 'react';
import { ZapIcon, Settings2Icon } from 'lucide-react';
interface HomeProps {
  onStart: () => void;
  onLeaderboards: () => void;
  onAdmin: () => void;
}
export function Home({
  onStart,
  onLeaderboards,
  onAdmin
}: HomeProps) {
  return <div className="min-h-screen bg-zinc-950 flex flex-col relative overflow-hidden" data-id="element-436">
      <div className="absolute top-0 left-0 w-1/2 h-full bg-orange-900/5 -skew-x-12 transform -translate-x-20 pointer-events-none" data-id="element-437" />
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cyan-900/5 -skew-x-12 transform translate-x-20 pointer-events-none" data-id="element-438" />

      <main className="flex-1 flex flex-col items-center justify-center p-4 z-10" data-id="element-439">
        <div className="text-center mb-16 relative" data-id="element-440">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-4" data-id="element-441">
            <h1 className="text-6xl md:text-9xl font-black text-white tracking-tighter italic uppercase" style={{
            fontFamily: 'Impact, sans-serif'
          }} data-id="element-442">
              <span className="text-orange-500 block md:inline" data-id="element-443">BRUTES</span>
            </h1>
            <div className="relative" data-id="element-444">
              <ZapIcon className="w-16 h-16 md:w-24 md:h-24 text-white fill-current animate-pulse" data-id="element-445" />
            </div>
            <h1 className="text-6xl md:text-9xl font-bold text-cyan-400 tracking-tighter font-mono" data-id="element-446">
              <span className="block md:inline" data-id="element-447">NERDS</span>
            </h1>
          </div>
          <p className="text-xl md:text-2xl text-gray-400 uppercase tracking-widest font-bold" data-id="element-448">
            The Ultimate Podcast Showdown
          </p>
        </div>

        <div className="w-full max-w-sm px-4" data-id="element-449">
          <button onClick={onStart} className="w-full bg-white text-black font-black uppercase tracking-wider text-xl md:text-2xl px-10 py-6 rounded-sm border-2 border-white shadow-[0_0_30px_rgba(255,255,255,0.2)] hover:shadow-[0_0_50px_rgba(255,255,255,0.4)] hover:bg-gray-200 transition-all duration-200 active:scale-95" data-id="element-450">
            START THE CHALLENGE
          </button>
        </div>
      </main>

      <footer className="p-6 flex flex-col items-center gap-3 z-10" data-id="element-451">
        <button onClick={onLeaderboards} className="text-gray-600 hover:text-gray-400 text-sm underline underline-offset-4 transition-colors" data-id="element-452">
          View Leaderboards
        </button>
        <p className="text-gray-700 text-xs font-semibold tracking-wider uppercase" data-id="element-453">
          LetLois LLC
        </p>
        <p className="text-gray-800 text-xs" data-id="element-454">
          © {new Date().getFullYear()} Podcast Games
        </p>
        {/* Admin access — subtle gear icon */}
        <button onClick={onAdmin} className="text-zinc-700 hover:text-zinc-500 transition-colors mt-1 p-1" aria-label="Admin Panel" data-id="element-455">
          <Settings2Icon className="w-4 h-4" data-id="element-456" />
        </button>
      </footer>
    </div>;
}